import { firebaseGetAllUsers } from "../Firebase";

export const fetchSessionUser = () => {
  const item = localStorage.getItem("user");
  if (item && item !== "undefined") {
    try {
      return JSON.parse(item);
    } catch (e) {
      localStorage.removeItem("user");
      return null;
    }
  }
  return null;
};
export const fetchSessionCart = () => {
  const item = localStorage.getItem("cartItems");
  if (item && item !== "undefined") {
    try {
      return JSON.parse(item);
    } catch (e) {
      localStorage.removeItem("cartItems");
      return [];
    }
  }
  return [];
};

// session usermode
export const fetchSessionUserMode = () => {
  const item = localStorage.getItem("adminMode");
  if (item && item !== "undefined") {
    try {
      const parsed = JSON.parse(item);
      return parsed ? parsed : false;
    } catch (e) {
      localStorage.removeItem("adminMode");
      return false;
    }
  }
  return false;
};
